<template>
  <div class="requestlistheader" :class="custDetail && custDetail.service_head === 'AIR' ?
  'global__bc_purple' : custDetail && custDetail.service_head === 'OCEAN' ?
  'global__bc_blue' : custDetail && custDetail.service_head === 'LAND' ?
  'global__bc_deepgreen' : ''">
    <div v-if="isLoading"
        class="spinner__medium--white d-flex align-items-center
        justify-content-center" style="height: 250px">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="row m-0" v-else-if="custDetail">
      <div class="row m-0 w-100">
        <div class="col-md-2 requestlistheader__block1" style="max-width: 144px;">
          <div class="back__button" @click="backToPrevious()">
            <img src="@/assets/image/icon/arrow-back-full-yellow.svg" alt="">
            <span class="pl-2">Back</span>
          </div>
          <div class="row m-0 my-1 align-items-center">
            <img class="img_shipment" :src="getImageShipment(custDetail.service_head)" alt="" />
            <h5 class="pl-2">{{typeRequest}}</h5>
          </div>
          <p>{{ getDateFormat1(custDetail.created_at) }}</p>
        </div>
        <div class="col-md requestlistheader__block2"
            :class="custDetail && custDetail.service_head === 'AIR' ?
            'border_purple' : 'border_blue'"
            style="min-width: 350px;">
          <div class="row m-0">
            <p class="col-md-1 p-0">Route</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0"> {{custDetail.cityf}} ({{custDetail.city_from}}) to
            {{ custDetail.cityt }} ({{custDetail.city_to}})</p>
          </div>
          <div class="row m-0">
            <p class="col-md-1 p-0">{{typeRequest}} {{'Number'}}</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0"> {{ custDetail.rfqnumber ?
            custDetail.rfqnumber.split('-').join('/') :  custDetail.contract_number.split('-').join('/') }}</p>
          </div>
          <div class="row m-0">
            <p class="col-md-1 p-0">Request Expired Date</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0"> {{getDateDefauld(custDetail.request_expired)}}</p>
          </div>
        </div>
        <div class="col-md requestlistheader__block3"
             :class="custDetail && custDetail.service_head === 'AIR' ?
              'border_purple' : 'border_blue'"
              style="min-width: 250px;">
          <div v-if="custDetail.service_head !== 'LAND'" class="row m-0">
            <p class="col-md-1 p-0">Shipment Service</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0">{{getServiceType(custDetail.optiontp)}}</p>
          </div>
          <div v-if="custDetail.service_head !== 'LAND'" class="row m-0">
            <p class="col-md-1 p-0">Shipment Type</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0">
              {{ getShipmentType(custDetail.shipment_type.replace(/SEA/g, '')) }}
            </p>
          </div>
          <div class="row m-0" v-if="typeRequest === 'RFQ'">
            <p class="col-md-1 p-0">Shipment Date</p> <span class="col-md-0 p-0 px-1">:</span>
            <p class="col-md p-0">{{ getDateDefauld(custDetail.cargo_readynes_date) }}</p>
          </div>
          <div class="row m-0" v-else>
            <p class="col-md-1 p-0">Contract Duration</p> <span class="col-md-0 p-0 px-1">:</span>
            <p class="col-md p-0">{{ getDateDefauld(custDetail.duration_start)}} - {{getDateDefauld(custDetail.duration_end)}}</p>
          </div>
        </div>
        <div class="col-md-2 requestlistheader__block4"
            :class="custDetail && custDetail.service_head === 'AIR' ?
            'border_purple' : 'border_blue'">
            <div>
              <p>Status:</p>
              <h6>{{getStatus(custDetail)}}</h6>
            </div>
        </div>
        <div
          v-if="$route.name === 'RequestListStatusRFQ'"
          class="col-md-2 requestlistheader__block5" 
          :class="custDetail && custDetail.service_head === 'AIR' 
            ? 'border_purple' 
            : 'border_blue'" 
        >
          <button 
            :style="custDetail && custDetail.service_head === 'AIR' 
              ? 'background-color: #673c86' 
              : custDetail.service_head === 'OCEAN' 
                ? 'background-color: #1D3354' 
                : 'background-color: #285231'"
            id="duplicate" 
            @click=duplicateRfq(custDetail)
          >
            Duplicate RFQ
          </button>
          <b-tooltip id="duplicate-rfq" target="duplicate" placement="bottomright">
            <div style="display: flex; padding: 9px 6px; column-gap: 4px">
              <img style="padding-top: 2px" src="@/assets/image/icon/information-circle-3.svg" width="14px" height="16px" />
              <p style="margin: 0">Duplicate this RFQ for the same details if you want to make another similar shipment</p>
            </div>
          </b-tooltip>
        </div>
      </div>
    </div>
    <div v-else class="fontstyle__infotext--white text-center">
      Sorry, something wrong please
      <span class="fontstyle__link--white" @click.prevent="reloadWindow()">try again</span>
    </div>
  </div>
</template>

<script>
import mixinShipmentDetails from '@/mixin/getters/shipment-details'
import mixinDateTime from '@/mixin/getters/date-time'
import mixinGetStatus from '@/mixin/getters/status-bid'

export default {
  name: 'HeaderBox',
  mixins: [mixinGetStatus, mixinShipmentDetails, mixinDateTime],
  props: {
    custDetail: Object,
    isLoading: Boolean,
    typeRequest: String,
    prevRoute: Object
  },
  methods: {
    reloadWindow () { // ntar ke mixin global
      window.location.reload()
    },
    getImageShipment (type) {
      if (type === 'OCEAN') {
        return require('@/assets/image/icon/shipment-ocean.svg')
      } else if (type === 'LAND') {
        return require('@/assets/image/icon/shipment-land.svg')
      }
      return require('@/assets/image/icon/shipment-air.svg')
    },
    backToPrevious () {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else if (this.typeRequest === 'RFQ') {
        this.$router.push({ name: 'RequestList', params: { type: 'rfq' } })
      } else {
        this.$router.push({ name: 'RequestList', params: { type: 'contract' } })
      }
    },

    duplicateRfq (data) {
      if (data.service_head === 'LAND') {
        this.$eventHub.$emit('duplicate-land', data.id)
        this.$router.push({ name: 'RequestShipment', params: { step: 'type-shipment' }, query: { mode: 'LAND' } })
      } else if (data.service_head === 'AIR') {
        this.$eventHub.$emit('duplicate-air', data.id)
        this.$router.push({ name: 'RequestShipment', params: { step: 'type-shipment' }, query: { mode: 'AIR' } })
      } else if (data.service_head === 'OCEAN') {
        this.$eventHub.$emit('duplicate-ocean', data.id)
        this.$router.push({ name: 'RequestShipment', params: { step: 'type-shipment' }, query: { mode: 'OCEAN' } })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/HeaderBox.vue